module.exports = __webpack_public_path__ + "img/hr-V-R-2-unload-connect.a87a3abd.png";